export enum UserRole {
  ADMIN = 'ADMIN',
  VENDOR = 'VENDOR'
}
